import { isBrowser } from '@/utils/environment';

export function openIntercomWindow() {
  if (isBrowser()) {
    try {
      Intercom('show');
    } catch (e) {
      alert('Open Intercom');
    }
  }
}

export function showIntercomDefaultLauncher() {
  if (isBrowser()) {
    try {
      Intercom('update', {
        hide_default_launcher: false,
      });
    } catch (e) {
      console.log('Show Intercom default launcher');
    }
  }
}

export function hideIntercomDefaultLauncher() {
  if (isBrowser()) {
    try {
      Intercom('update', {
        hide_default_launcher: true,
      });
    } catch (e) {
      console.log('Hide Intercom default launcher');
    }
  }
}
